import { theme } from "@tm/utility/global";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import type { ITravellerDetailsFormV2 } from "../../../AddTravellerDetail/type";
import FormattedText from "../../../FormattedText/FormattedText";
import ParaTag from "../../../TextStyles/ParaTag";
import { useTravellerDetailsContext } from "../../contexts/TravellerDetailsV2Context";
import { Box, Link, Row, Wrap } from "./Styles";

export const TncSection = ({
  tnc,
  link,
  error,
}: {
  tnc?: string[];
  link?: { title?: string; url?: string };
  error?: { message?: string };
}) => {
  const { handleTncCheckbox, tncRef } = useTravellerDetailsContext();
  const {
    control,
    formState: { errors },
  } = useFormContext<ITravellerDetailsFormV2>();

  const tncError = errors.tncs?.find?.((item) => item?.message);

  return (
    <Wrap ref={tncRef}>
      {tnc?.map((tncElement, index) => (
        <Controller
          key={index}
          control={control}
          name={`tncs.${index}`}
          rules={{
            required: {
              value: true,
              message: "Please confirm",
            },
          }}
          render={({ field: { value } }) => (
            <Row>
              <Box
                type="checkbox"
                checked={Boolean(value)}
                onChange={() => handleTncCheckbox?.(index)}
              />
              <span>
                {typeof tncElement === "string" ? (
                  tncElement
                ) : (
                  <FormattedText value={tncElement as any} />
                )}
                {link?.url ? (
                  <>
                    {" "}
                    <Link href={link.url} target="_blank" rel="noopener noreferrer">
                      {link.title || "Terms and conditions"}
                    </Link>
                  </>
                ) : null}
              </span>
            </Row>
          )}
        />
      ))}

      {tncError ? (
        <ParaTag margin="8px 0 0 4px" color={theme.redText2} fontSize="xs">
          {error?.message || "Please confirm"}
        </ParaTag>
      ) : null}
    </Wrap>
  );
};
